export class AlertContent {

  cause: string
  success: boolean
  msg: string
  snackbar: boolean

  constructor(data: any = {}) {
    this.cause = data.cause || null
    this.success = Boolean(data.success)
    this.msg = data.msg || null
    this.snackbar = data.snackbar === false ? false : true
  }

  get showSnackbar(): boolean {
    return Boolean(this.snackbar && this.msg)
  }

  get colorClass(): string {
    return this.success ? 'success' : 'danger'
  }

}



// WEBPACK FOOTER //
// ./src/app/models/app/alert-content.ts